import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import {
  AddressBookFieldNames,
  AddressBookResponse,
  AddressResponse,
  FilterCombinator,
  FilterComparator,
  FindAddressQuery,
  FindAddressQueryHandler,
  OrderType,
  SearchAddressBooksQuery,
  SearchAddressBooksQueryHandler,
  SearchAddressesQuery,
  SearchAddressesQueryHandler,
} from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class AddressbookQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly searchAddressBooksQueryHandler: SearchAddressBooksQueryHandler;
  private readonly searchAddressesQueryHandler: SearchAddressesQueryHandler;
  private readonly findAddressQueryHandler: FindAddressQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchAddressBooksQueryHandler = new SearchAddressBooksQueryHandler(queryRepository);
    this.searchAddressesQueryHandler = new SearchAddressesQueryHandler(queryRepository);
    this.findAddressQueryHandler = new FindAddressQueryHandler(queryRepository);
  }

  public searchAddressBook(searchText: string): Promise<AddressBookResponse[]> {
    const query = {
      criteriaPayload: {
        filters: [
          {
            combinator: FilterCombinator.NONE,
            field: AddressBookFieldNames.CITY,
            comparator: FilterComparator.ILIKE,
            value: searchText,
          },
          {
            combinator: FilterCombinator.OR,
            field: AddressBookFieldNames.COMPANY_NAME,
            comparator: FilterComparator.ILIKE,
            value: searchText,
          },
          {
            combinator: FilterCombinator.OR,
            field: AddressBookFieldNames.POSTAL_CODE,
            comparator: FilterComparator.ILIKE,
            value: searchText,
          },
          {
            combinator: FilterCombinator.OR,
            field: AddressBookFieldNames.STREET,
            comparator: FilterComparator.ILIKE,
            value: searchText,
          },
          {
            combinator: FilterCombinator.OR,
            field: AddressBookFieldNames.STOP_INSTRUCTIONS,
            comparator: FilterComparator.ILIKE,
            value: searchText,
          },
        ],
        order: [
          {
            field: AddressBookFieldNames.STREET,
            type: OrderType.ASC,
          },
        ],
        pageIndex: 0,
        pageSize: 5,
      },
    } as SearchAddressBooksQuery;
    return this.searchAddressBooksQueryHandler.handle(query);
  }

  public findPlaceAddress(placeId: string): Promise<AddressResponse> {
    const query = {
      predictionId: placeId,
    } as FindAddressQuery;
    return this.findAddressQueryHandler.handle(query);
  }

  // TODO refactor, use abortSignal
  public async searchPlaceAddress(params: any, term: string, abortSignal?: AbortSignal): Promise<any> {
    const query = {
      address: term,
    } as SearchAddressesQuery;
    return this.searchAddressesQueryHandler.handle(query);
  }

  public async findByPlaceId(params: any): Promise<any> {
    return this.findPlaceAddress(params);
  }
}
